import { MarketLanguage } from '../store';

import { fixLangCode } from '@core/application/use-cases/languages/fix-lang-code.use-case';
import { routerPublicModels } from '@frontend/libs/duttirouter';
import { StoreDetail, StoreLanguage } from '@mdfrontw/core';

export function getUrlWithoutCountryLangFromRoute(mergedRoute: routerPublicModels.MergedRoute): string {
    let url: string = mergedRoute.url;
    if (mergedRoute.params.countryCode) {
        url = url.replace(`/${mergedRoute.params.countryCode}`, '');
    }

    if (mergedRoute.params.langCode || mergedRoute.params.catalog) {
        url = url.replace(`/${mergedRoute.params.langCode || mergedRoute.params.catalog}`, '');
    }
    return url;
}

export function generateMarketLanguageFromPath(
    store: StoreDetail,
    language: StoreLanguage,
    path: string,
    domain: string,
): MarketLanguage {
    const pathWithoutSlash = path.startsWith('/') ? path.substring(1) : path;
    const baseCountryCode = store.countryCode.toLocaleLowerCase();
    const requestedLang = language.code;
    const storeDefaultLang = store.supportedLanguages.find((lang) => lang.id === store.storeDefaultLanguageId);
    const requestedEqualsDefault = requestedLang === storeDefaultLang?.code;
    const languagePath = requestedEqualsDefault ? '/' : `/${requestedLang}/`;

    const languageUrl = `${domain}/${baseCountryCode}${languagePath}${pathWithoutSlash}`;
    const baseUrl = `${domain}/${baseCountryCode}${languagePath}`;

    return {
        ...language,
        codeTemplate: fixLangCode(language.code, store.countryCode),
        href: languageUrl,
        baseUrl,
    };
}
